import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Pagination from '../../constant/Pagination';
import TableLoaderEffect from '../../constant/TableLoader';
import { getPerishableStocksList, exportPerishableStocksList } from '../../../services/ProductService';
import DebounceSearchInput from '../../constant/DebounceSearchInput';
import ExportModal from '../../constant/ExportModal';
const expiryTypeBtnList = ["Expiry Soon", "Expired"]


const PerishableStock = (props) => {
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const [total, setTotal] = useState(0)
    const [filter, setFilter] = useState({
        page: 1,
        page_size: 10,
        query: '',
        expiry_type: expiryTypeBtnList[0]
    })

    useEffect(() => {
        setIsLoading(true)
        getPerishableStocksList(filter).then((resp) => {
            if (resp) {
                setData(resp.data.data)
                setTotal(resp.data.total)
            }
        }).catch((error) => {
            console.log(error.response.data.message)
        }).finally(() => {
            setIsLoading(false)
        })
    }, [filter])


    const handlePagination = page => {
        setFilter({ ...filter, page: page.selected + 1 })
    }

    const handleSearchChange = (value) => {
        setFilter({ ...filter, query: value, page: 1 })
    }

    const handleExpiryTypeChange = (expiry_type) => {
        setFilter({ ...filter, expiry_type, page: 1 })

    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-12">
                    <div className="card">
                        <div className="card-body p-0">
                            <div className="d-flex justify-content-between text-wrap align-items-center p-3">
                                <h4 className="mb-0">Perishable Stocks</h4>

                                <div className='d-flex align-items-center flex-wrap gap-3'>
                                    <div>
                                        <div className="btn-group" role="group" aria-label="Small button group">
                                            {expiryTypeBtnList.map(item => (
                                                <button key={item} type="button"
                                                    className={`btn ${filter.expiry_type === item ? "btn-primary" : "btn-outline-primary"}`}
                                                    onClick={() => handleExpiryTypeChange(item)}>{item}</button>
                                            ))}
                                        </div>
                                    </div>

                                    <div>
                                        <DebounceSearchInput handleSearchChange={handleSearchChange} />
                                    </div>

                                    <div>
                                        <ExportModal
                                            exportApi={exportPerishableStocksList}
                                            params={{
                                                query: filter.query,
                                                expiry_type: filter.expiry_type
                                            }}
                                            title={`Export ${filter.expiry_type} Perishable Stocks`}
                                        />
                                    </div>
                                </div>
                            </div>


                            <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                <div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
                                    <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
                                        <thead>
                                            <tr>
                                                <th>Barcode</th>
                                                <th>Material</th>
                                                <th>Rack</th>
                                                <th>Quantity</th>
                                                <th>Expiry Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {isLoading ? <TableLoaderEffect colLength={7} /> : data.map((item, index) => (
                                                <tr key={index}>
                                                    <td><span>{item.barcode}</span></td>
                                                    <td>
                                                        <Link to={`/material/${item.product.id}`}>{item.product.name}</Link>
                                                    </td>
                                                    <td><span>{item.rack}</span></td>
                                                    <td><span>{item.quantity}</span></td>
                                                    <td><span>{item.expired_date}</span></td>
                                                </tr>
                                            ))}
                                        </tbody>

                                    </table>
                                    {props.isLoading ? <div style={{ height: '4rem' }}></div> : <Pagination
                                        currentPage={filter.page}
                                        recordsPage={filter.page_size}
                                        dataLength={total}
                                        handlePagination={handlePagination}
                                    />
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default PerishableStock;


